var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('main',{staticClass:"app-main-shell"},[_c('router-view')],1),_c('footer-div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }